module.exports = __webpack_public_path__ + "img/sidenav-item-settings.9a2b6bec.svg";